import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["type", "title", "icon", "content", "fullWidth", "horizontalPadding", "action"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Notification/Notification.js",
  _this = this,
  _notificationBg,
  _templateObject,
  _templateObject2;
import React from 'react';
import styled, { css } from 'styled-components';
import { useTheme, withTheme } from '../../core/ThemeProvider';
import { testIdProps } from '../../helpers';
import NoGutterYGrid from './NoGutterYGrid';
import Text from '../Text';
import Button from '../Button';
import TextLink from '../TextLink';
import Row from '../Row';
import Column from '../Column';
import { ActionTypes, HorizontalPaddingTypes, NotificationTypes } from './types';
import Inline from '../Inline';
import config from '../../config';
export var testIds = {
  action: 'notificationAction'
};
var Notification = function Notification(_ref) {
  var type = _ref.type,
    title = _ref.title,
    icon = _ref.icon,
    content = _ref.content,
    fullWidth = _ref.fullWidth,
    horizontalPadding = _ref.horizontalPadding,
    _ref$action = _ref.action,
    action = _ref$action === void 0 ? {} : _ref$action,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var paddingX = fullWidth ? 0 : getPaddingX(horizontalPadding, theme);
  var paddingY = theme.space_4;
  var hasContent = !!content;
  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Text, {
      type: "boldBody",
      lineHeight: "compact",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 9
      }
    }, title), content && /*#__PURE__*/React.createElement(_StyledText, {
      type: "smallBody",
      lineHeight: "compact",
      $_css: theme.space_1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 9
      }
    }, content));
  };
  return /*#__PURE__*/React.createElement(NotificationContainer, _extends({
    type: type,
    paddingX: paddingX,
    paddingY: paddingY,
    fullWidth: fullWidth
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 5
    }
  }), title && icon && /*#__PURE__*/React.createElement(TitleIcon, {
    "data-testid": "title-icon",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 25
    }
  }, icon), fullWidth && type !== NotificationTypes.promo && action.type === ActionTypes.button ? /*#__PURE__*/React.createElement(StyledInline, {
    align: "spaceBetween",
    alignY: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 72,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  }, renderContent()), action.type === ActionTypes.button && /*#__PURE__*/React.createElement(ActionContainer, {
    type: action.type,
    noMargin: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 13
    }
  }, renderAction(type, action, hasContent))) : /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 9
    }
  }, renderContent(), action && action.text && /*#__PURE__*/React.createElement(ActionContainer, {
    type: action.type,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 13
    }
  }, renderAction(type, action, hasContent))));
};
var renderAction = function renderAction(notificationType, _ref2, useSmallBody) {
  var _ref2$type = _ref2.type,
    type = _ref2$type === void 0 ? ActionTypes.link : _ref2$type,
    onClick = _ref2.onClick,
    text = _ref2.text;
  var _type = type;
  if (notificationType === NotificationTypes.promo && type === ActionTypes.button) {
    console.warn('notification type="promo" can only show actionable items as link only. action.type="link"');
    _type = ActionTypes.link;
  }
  switch (_type) {
    case ActionTypes.button:
      return /*#__PURE__*/React.createElement(Button, {
        onClick: onClick,
        "data-testid": testIds.action,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 114,
          columnNumber: 9
        }
      }, text);
    case ActionTypes.link:
      return /*#__PURE__*/React.createElement(Text, {
        type: useSmallBody ? 'smallBody' : 'body',
        lineHeight: "compact",
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 121,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(TextLink, {
        onClick: onClick,
        "data-testid": testIds.action,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 122,
          columnNumber: 11
        }
      }, text));
  }
};
Notification.defaultProps = {
  type: NotificationTypes.info,
  horizontalPadding: 'md',
  fullWidth: false
};
export default Notification;
var notificationBg = (_notificationBg = {}, _defineProperty(_notificationBg, NotificationTypes.alert, 'cl_pri_l3'), _defineProperty(_notificationBg, NotificationTypes.info, 'cl_ter_l6'), _defineProperty(_notificationBg, NotificationTypes.promo, 'cl_sec_l2'), _notificationBg);
var getPaddingX = function getPaddingX(padding, theme) {
  return theme[HorizontalPaddingTypes[padding]];
};
var NotificationContainer = withTheme(styled(function (_ref3) {
  var children = _ref3.children,
    fullWidth = _ref3.fullWidth,
    className = _ref3.className;
  return fullWidth ? /*#__PURE__*/React.createElement("div", {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 193,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(_StyledNoGutterYGrid, {
    noGutterY: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 194,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Row, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(_StyledColumn, {
    style: {
      display: 'flex',
      flexDirection: 'row'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 13
    }
  }, children)))) : /*#__PURE__*/React.createElement("div", {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 209,
      columnNumber: 7
    }
  }, children);
}).withConfig({
  displayName: "Notification__NotificationContainer",
  componentId: "sc-18glugq-0"
})(function (p) {
  var style = {
    display: 'flex',
    flex: 1
  };
  style.padding = "".concat(p.paddingY, "px ").concat(p.paddingX, "px");
  style.backgroundColor = p.coreTheme[notificationBg[p.type]];
  !p.fullWidth && (style.borderRadius = p.coreTheme.rad_xs);
  return style;
}));
var ActionContainer = withTheme(styled.div.withConfig({
  displayName: "Notification__ActionContainer",
  componentId: "sc-18glugq-1"
})(function (p) {
  return css(["margin-top:", "px;", ""], p.type === ActionTypes.link ? p.coreTheme.space_1 : p.coreTheme.space_4, p.type === ActionTypes.button && css(["", ""], config.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          margin-top: 0;\n        "])))));
}));
var StyledInline = withTheme(styled(Inline).withConfig({
  displayName: "Notification__StyledInline",
  componentId: "sc-18glugq-2"
})(["flex:1;flex-direction:column;align-items:flex-start;@media (min-width:", "){flex-direction:row;align-items:center;}"], function (p) {
  return p.coreTheme.brk_xs;
}));
var TitleIcon = withTheme(styled.div.withConfig({
  displayName: "Notification__TitleIcon",
  componentId: "sc-18glugq-3"
})(["margin-right:", "px;", " svg{width:", "px;height:", "px;}"], function (p) {
  return p.coreTheme.space_2;
}, config.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nmargin-right: ", "px;\n"])), function (p) {
  return p.coreTheme.space_3;
}), function (p) {
  return p.coreTheme.space_6;
}, function (p) {
  return p.coreTheme.space_6;
}));
var _StyledText = styled(Text).withConfig({
  displayName: "Notification___StyledText",
  componentId: "sc-18glugq-4"
})(function (p) {
  return {
    marginTop: p.$_css
  };
});
var _StyledNoGutterYGrid = styled(NoGutterYGrid).withConfig({
  displayName: "Notification___StyledNoGutterYGrid",
  componentId: "sc-18glugq-5"
})({
  width: '100%',
  paddingTop: 0,
  paddingBottom: 0
});
var _StyledColumn = styled(Column).withConfig({
  displayName: "Notification___StyledColumn",
  componentId: "sc-18glugq-6"
})({
  paddingTop: 0,
  paddingBottom: 0
});